<!-- eslint-disable vue/no-v-html -->
<template>
  <div class="wrap">
    <div class="board">
      <ShowTitle></ShowTitle>
      <div class="board_detail">
        <div class="container">
          <div class="board_warp">
            <div class="title_area">
              <div class="title">{{ detailData.title }}</div>
              <!-- <div class="info" v-if="Object.keys(detailData).length > 0"> -->
              <div class="info">
                <span>작성자:관리자</span>
                <!-- <span>{{ detailData.created_at.split(' ')[0] }}</span> -->
                <span>{{ createDate.slice(0, 10) }}</span>
              </div>
            </div>
            <div class="contents_area">
              <!-- <pre id="description">{{detailData.description}}</pre> -->
              <div
                v-if="detailData.description"
                v-html="detailData.description"
              ></div>
              <div v-else>게시글이 존재하지 않습니다.</div>
            </div>

            <div v-if="Object.keys(attachments).length > 0" class="page_move">
              <div class="border_line"></div>
              <table>
                <colgroup>
                  <col width="100px" />
                  <col width="100px" />
                  <col width="50%" />
                  <col width="200px" />
                  <col width="200px" />
                </colgroup>

                <thead>
                  <tr>
                    <th class="bold">첨부파일</th>
                    <td colspan="4">
                      <div class="pointer">{{ attachments }}</div>
                    </td>
                  </tr>
                </thead>
              </table>
            </div>

            <div class="page_move">
              <table>
                <colgroup>
                  <col width="100px" />
                  <col width="100px" />
                  <col width="50%" />
                  <col width="200px" />
                  <col width="200px" />
                </colgroup>
                <tbody>
                  <tr v-if="Object.keys(prevData).length > 0">
                    <th class="bold">이전</th>
                    <td></td>
                    <!-- <td> {{ prev.idx }} </td> -->
                    <!-- <td class="subject"><a href="/notice/{{ prevData.idx }}">{{prevData.title}}</a></td> -->
                    <td class="subject">
                      <a
                        @click="getIdx(prevData.idx)"
                        v-html="prevData.title"
                      ></a>
                    </td>
                    <!-- <td class="subject"><a @click="getIdx(prevData.idx )">{{prevData.title}}</a></td> -->
                    <td>관리자</td>
                    <td>{{ prevData.created_at.split(' ')[0] }}</td>
                  </tr>
                  <tr v-else>
                    <th class="bold">이전</th>
                    <td></td>
                    <td class="subject">이전 게시글이 없습니다.</td>
                    <td></td>
                    <td></td>
                  </tr>

                  <tr v-if="Object.keys(nextData).length > 0">
                    <th class="bold">다음</th>
                    <td></td>
                    <!-- <td>{{ next.idx }}</td> -->
                    <!-- <td class="subject"><a href="/notice/{{ nextData.idx }}">{{ nextData.title }}</a></td> -->
                    <td class="subject">
                      <a
                        @click="getIdx(nextData.idx)"
                        v-html="nextData.title"
                      ></a>
                    </td>
                    <!-- <td class="subject"><a @click="getIdx(nextData.idx )">{{ nextData.title }}</a></td> -->
                    <td>관리자</td>
                    <td>{{ nextData.created_at.split(' ')[0] }}</td>
                  </tr>
                  <tr v-else>
                    <th class="bold">다음</th>
                    <td></td>
                    <td class="subject">다음 게시글이 없습니다.</td>
                    <td></td>
                    <td></td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div class="more_list">
              <!-- <a href="/notice">목록</a> -->
              <router-link to="/notice"> 목록 </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, watch, getCurrentInstance } from 'vue'
import { useRoute } from 'vue-router'
import ShowTitle from '../components/ShowTitle.vue'
import { loadDetailNotice } from '../api/boards'

export default {
  name: 'NoticeDetailViews',
  components: {
    ShowTitle,
  },
  setup() {
    const router = getCurrentInstance().proxy.$router

    const route = useRoute()
    const noticeId = ref(null)
    const detailData = ref([])
    const createDate = ref([])
    const prevData = ref([])
    const nextData = ref([])
    const attachments = ref([])

    // // console.log(detailData.created_at);
    const getData = async () => {
      try {
        noticeId.value = route.params.noticeId
        const response = await loadDetailNotice(noticeId.value)
        detailData.value = response.data.content
        if (response.data.content.created_at) {
          createDate.value = response.data.content.created_at
        }
        // console.log(response.data.content)
        prevData.value = response.data.content.prev
        // console.log('prevData.value :: ', prevData.value)
        nextData.value = response.data.content.next
        attachments.value = response.data.content.attachments
      } catch (error) {
        // console.error('상세페이지로 이동 실패:', error)
      }
    }
    const getIdx = async (noitceId) => {
      router.push(`/notice/${noitceId}`)
      // try{
      //     const detailRes = await loadDetailNotice(noitceId);
      //     if(detailRes.data.status_code === 200) {
      //       router.push(`/notice/${noitceId}`)

      //     }
      // } catch(error){
      //      console.error('상세페이지로 이동 실패:', error);
      // }
    }
    onMounted(() => {
      getData()
    })
    watch(() => route.params, getData)

    return {
      noticeId,
      detailData,
      prevData,
      nextData,
      attachments,
      getData,
      getIdx,
      createDate,
    }
  },
}
</script>
